export const defaultStyle = {
  richTextWrapper:
    "richTextWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[35px] md:px-[15px] lg:px-[15px] pb-[30px] lg:pb-[50px] py-35 md:pt-[0px]",
  title:
    "title badgeHeading text-left font-Light font-[300] text-[24px] lg:text-[48px] text-green mb-[35px] tracking-normal md:leading-[50px] test",
  shortDescription:
    'relative shortDescription [&>p]:mb-20 [&>p>a]:!text-purple [&>p>a:hover]:!text-orange [&>p>strong>a]:!text-[#4f2170] [&>p>strong>a:hover]:!text-orange [&>p>a]:tracking-[0.53px] md:[&>p>a]:!tracking-[2.2px] [&>p>a]:font-bold [&>.contactPara]:mb-[60px] [&>.contactPara>p]:mb-0 [&>ul>li>a]:font-bold [&>ul>li>a]:tracking-[2.2px] [&>ul]:mb-[35px] [&>ul>li>a]:!text-purple [&>ul>li>a:hover]:!text-orange [&>ul>li>a]:tracking-[2.2px] [&>ul>li>a]:font-bold [&>ul]:mb-16 break-words md:px-[20px] lg:px-[0px] [&>section>h2]:text-[#287819] [&>section>h2]:text-[48px] [&>section>h2]:font-[300] [&>section>h2]:mb-[35px] [&>section>h2]:font-Light [&>section>span]:text-16 [&>.careerPara]:text-center [&>.careerPara]:py-[30px] [&>.careerPara]:lg:py-[50px] [&>p>.ot-sdk-show-settings]:text-[16px] [&>p>.ot-sdk-show-settings]:border-2 [&>p>.ot-sdk-show-settings]:px-[6px] [&>p>.ot-sdk-show-settings]:bg-buttonFace [&>p>.ot-sdk-show-settings]:py-[1px] [&>p>.ot-sdk-show-settings]:font-["Segoe_UI"]',
  selectWrapper: "selectWrapper mt-[30px] my-[50px]",
  selectDropdown: "selectDropdown",
}

export const RICHTEXR_WRAP_WITH_SPACING = {
  //this will use when spacing top and bottom required for RichText wrapper
  ...defaultStyle,
  richTextWrapper:
    "richTextWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[35px] md:px-[15px] lg:px-[15px] pb-[30px] lg:pb-[50px] py-[30px] lg:py-[50px]",
}

export const RICHTEXT_CENTER_ALIGNED = {
  ...defaultStyle,
  richTextWrapper:
    "richTextWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[35px] md:px-[15px] lg:px-[15px] text-center mb-[35px]",
  title:
    "title badgeHeading capitalize text-center font-Light text-[24px] lg:text-[48px] text-green mb-[35px] lg:leading-[57px]",
  shortDescription:
    "shortDescription [&>h2]:font-Light [&>h2]:text-center [&>h2]:text-green lg:[&>h2]:text-[48px] [&>h2]:text-[24px] [&>h2]:mb-[35px] max:md:[&>h2]:leading-[28.8px] [&>h2]:tracking-normal ",
}

export const SECTION_9_3_PART_TABCONTAINER = {
  //NOTE :SPECIALLY this variant is used for /makers-bakers-bulletin-board page
  ...defaultStyle,
  richTextWrapper:
    "richTextWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto pb-[30px] lg:pb-[50px]",
  shortDescription:
    "shortDescription [&>h5]:text-[16px] [&>h5]:leading-[18px] [&>h5]:mb-5 [&>h5]:italic [&>h3]:!text-green [&>p]:mb-20 [&>p>a]:!text-purple [&>p>em]:text-[16px] [&>p>a:hover]:!text-orange [&>p>strong>a]:!text-[#4f2170] [&>p>strong>a:hover]:!text-orange [&>p>a]:tracking-[0.53px] md:[&>p>a]:!tracking-[2.2px] [&>p>a]:font-bold [&>.contactPara]:mb-[60px] [&>.contactPara>p]:mb-0 [&>ul>li>a]:font-bold [&>ul>li>a]:tracking-[2.2px] [&>ul]:mb-[35px] [&>ul>li>a]:!text-purple [&>ul>li>a:hover]:!text-orange [&>ul>li>a]:tracking-[2.2px] [&>ul>li>a]:font-bold [&>ul]:mb-16 break-words md:px-[20px] lg:px-[0px] [&>section>h2]:text-[#287819] [&>section>h2]:text-[48px] [&>section>h2]:font-[300] [&>section>h2]:mb-[35px] [&>section>h2]:font-Light [&>section>span]:text-16 [&>p>strong>span]:border-b-[2px] [&>p>strong>span]:border-solid",
}

export const TABBING_WITH_LANG = {
  richTextWrapper: "md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto",
  shortDescription:
    "facebookIcon px-[16px] [&>p]:mb-[35px] [&>details]:text-[16px] [&>details]:!tracking-normal [&>details>span]:!text-center",
}
export const CONTENT_WITH_LINKS = {
  ...defaultStyle,
  richTextWrapper:
    "richTextWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[35px] lg:px-[15px] py-[30px] md:py-[30px] lg:py-[50px]",
  shortDescription:
    "shortDescription [&>p]:mb-[35px] last:[&>p]:mb-[0px] [&>p>a]:text-purple [&>p>a]:font-bold [&>p>a]:!tracking-[0.53px] md:[&>p>a]:!tracking-[2.2px] [&>p>a:hover]:!text-orange [&>p>a:hover]:!border-b-2 [&>p>a:hover]:!border-solid [&>p>a:hover]:!no-underline",
}

export const COOKIES_INFO = {
  richTextWrapper:
    "richTextWrapper text-left px-8 lg:pt-0 pb-[25px] lg:w-[1170px] text-[15px] lg:mb-[45px] lg:mx-auto my-0",
  title: "text-center text-25 leading-25 py-25 tracking-[1px]",
  code: "",
  paragraph: "paragraph",
  list: "list pb-[1.1em] list-none tracking-[0]",
  ulList: "listui",
  mainLink: "",
  link: "",
  table: "border-separate border-spacing-0 curved-table lg:mb-30 mb-10",
  tRow: "rounded-[0px]",
  tHeader:
    "bg-greyLightSmoke text-14 first:rounded-tl-[5px] last:rounded-tr-[5px]",
  tData: "",
  mainLink: "mainLink buttonEffect2 text-white",
  tableCls: "mb-[32px]",
}

export const NEWSPAGE_DETAIL = {
  richTextWrapper: "richTextWrapper w-full newstex-wrap  lg:pl-[0px]",
  title:
    "md:text-[60px] tracking-[0.45px] md:tracking-[1.2px] text-purple uppercase md:mb-[85px] font-400 text-[36px] mb-[25px] font-MDLZBiteType leading-[1.2]",
  shortDescription: "shortDescription",
  paragraph: "paragraph test",
  list: "list pb-[1.1em] list-none tracking-[0]",
  ulList: "listui",
  mainLink: "",
  link: "",
  table: "border-separate border-spacing-0 curved-table lg:mb-30 mb-10",
  tRow: "rounded-[0px]",
  tHeader:
    "bg-greyLightSmoke  text-14 first:rounded-tl-[5px] last:rounded-tr-[5px]",
  tData: "",
  mainLink: "mainLink buttonEffect2 text-white",
  tableCls: "mb-[32px]",
}

export const ABOUT_US = {
  richTextWrapper:
    "richTextWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-30 md:px-15",
  title:
    "title text-left font-MDLZBiteType text-purple text-[36px] md:text-[60px] leading-25 pb-[70px] tracking-[1.2px]",
  shortDescription:
    "shortDescription text-green text-[24px] font-Light leading-[1.2] m-normal md:[&>p]:px-20 [&>p]:px-0",
}

export const H1_HEADING_PURPLE = {
  richTextWrapper:
    "richTextWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto py-35 px-35 md:py-0 md:px-15 mb-40",
  title:
    "title uppercase text-left font-MDLZBiteType text-purple text-[36px] md:text-[60px] pb-[30px] md:pb-[70px] md:tracking-[1.2px] leading-[1.2] md:leading-[72px]",
}

export const H2_HEADING_GREEN = {
  richTextWrapper:
    "richTextWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-35 md:px-15 pb-[30px] lg:pb-[50px]",
  title:
    "badgeHeading text-left font-[300] text-[24px] lg:text-[48px] text-green mb-[35px] leading-[1.2] lg:leading-[57px] tracking-normal font-Light",
  shortDescription:
    "shortDescription  text-[#29333d] [&>p>a]:text-purple [&>p>a]:tracking-[2.2px] [&>p>a]:font-bold [&>p>a:hover]:text-orange [&>p>a:hover]:underline [&>p>em>a]:text-purple [&>p>em>a]:tracking-[2.2px] [&>p>em>a]:font-bold [&>p>em>a:hover]:text-orange [&>p>em>a:hover]:underline [&>p]:md:leading-[31.5px]",
}

export const FOOTNOTES = {
  richTextWrapper:
    "footnotes md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[35px] lg:px-[15px] italic text-[14px] tracking-[0.53px] leading-[21px] font-Regular md:max-w-md lg:max-w-lg xl:max-w-xl md:px-[15px] px-[35px] mr-auto pb-[35px] [&>div>div>p>a:hover]:text-[#CB4E0B]",
}

export const PACKAGING_PLASTICS_TEXT_CONTENT = {
  richTextWrapper:
    "richTextWrapper w-full packing-text-wrap md:max-w-md xl:max-w-xl max-[991.99px]:mb-[30px] flex lg:max-w-lg px-[15px] mx-auto ",
  title:
    "title text-left font-MDLZBiteType text-purple text-[36px] md:text-[60px] leading-25 md:leading-[72px] pb-[70px] tracking-[1.2px]",
  shortDescription:
    "shortDescription text-black text-[14px] md:text-[21px] font-Regular mb-[25px] lg:mb-[35px] leading-[21px] md:leading-[31.5px] tracking-[0.53px] lg:[&>p]:px-0 [&>p]:px-[20px]",
}
export const TEXT_WITH_LINK = {
  ...H2_HEADING_GREEN,
  richTextWrapper:
    "richTextWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-15 mb-[50px]",
  shortDescription:
    "shortDescription [&>div]:flex [&>div]:flex-col [&>div]:lg:flex-row [&>div]:justify-around pt-[50px] [&>div>ul]:pl-[35px] [&>div>ul]:pr-[30px] [&>div>ul]:mb-[30px] text-[14px] md:text-[21px] text-[#4f2170] font-normal [&>div>ul>li>a]:font-bold md:font-Regular tracking-[0.53px] md:tracking-[2.2px]",
}

export const TEXT_WITH_LINK_BOLD = {
  ...TEXT_WITH_LINK,
  richTextWrapper:
    "richTextWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[30px] md:py-[50px]",
  shortDescription:
    "shortDescription [&>div]:flex [&>div]:flex-col [&>div]:lg:flex-row [&>div]:justify-around [&>ul]:px-[40px] [&>div>ul]:pr-[30px] [&>div>ul]:mb-[30px] text-[14px] md:text-[21px] [&>ul>li>a]:text-[14px] md:[&>ul>li>a]:text-[21px]  [&>ul>li>a]:text-purple [&>ul>li]:mb-[8px] [&>ul>li>a]:font-bold md:font-Regular tracking-[0.53px] md:tracking-[2.2px]",
  title:
    "badgeHeading text-left font-Light text-[14px] text-black mb-[16px] leading-[1.2] lg:leading-[50px] px-[20px] md:px-[20px] lg:px-[0px]",
}

export const GREEN_BG_SECTION = {
  richTextWrapperForBg:
    "richTextWrapperForBg mx-auto pb-[50px] md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto",
  richTextWrapper:
    "richTextWrapper p-20 lg:p-[30px] bg-darkGreen text-white min-h-[80px]",
  title: "title",
  shortDescription: "shortDescription text-14 lg:text-[20px] pr-[20px] lg:pr-0",
}

export const BOLD_H2_HEADING_GREEN = {
  ...H2_HEADING_GREEN,
  richTextWrapper:
    "richTextWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto pb-35 px-30 md:px-[15px] lg:px-[15px] md:py-0 lg:mb-50",
  title:
    "title badgeHeading  text-left font-Regular font-bold text-[24px] lg:text-[40px] text-green mb-[10px] tracking-[1.2px] leading-[50px]",
  shortDescription:
    "shortDescription text-[14px] lg:text-[20px] [&>p>a]:font-MDLZBiteType [&>p>a]:text-purple [&>p>a]:tracking-[2.2px] [&>p>a]:font-bold [&>p>a:hover]:text-orange [&>p>a:hover]:underline",
}

export const HEADING_CONTENT_ONE = {
  richTextWrapper:
    "richTextWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-15 mb-[50px]",
  title:
    "block text-4xl md:text-6xl mb-[20px] text-[#4f2170] md:leading-none leading-[1.2] tracking-2 font-MDLZBiteType inline-flex  uppercase block block-start-8 text-left",
  shortDescription:
    "shortDescription [&>p>a]:text-purple [&>p>a]:tracking-[2.2px] [&>p>a]:font-bold",
}
export const NOTIFICATION = {
  richTextWrapper:
    "richTextWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-15 mb-[50px]",
  title:
    "title badgeHeading capitalize text-left font-Light text-[24px] lg:text-[48px] text-green mb-[35px] tracking-[1.2px] leading-[50px]",
  shortDescription:
    "notificatonWrap shortDescription text-black text-14 px-20 font-regular italic",
}

export const NOTIFICATION_LEFT_ALIGNED = {
  ...NOTIFICATION,
  richTextWrapper:
    "richTextWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto  mb-[50px]",
  shortDescription:
    "notificatonWrap shortDescription text-black text-14 font-regular italic text-left",
}

export const H3_BLUE = {
  ...H2_HEADING_GREEN,
  title:
    "textHead text-blue500 font-MDLZBiteType text-[16px] md:text-[28px] leading-[1.2] mb-[8px] tracking-normal",
}
export const HEADING_H1 = {
  ...defaultStyle,
  richTextWrapper:
    "richTextWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-35 md:px-[15px] pb-[30px]",
  title:
    "title badgeHeading capitalize text-left font-Light text-[24px] lg:text-[48px] text-green mb-[35px] tracking-[1.2px] leading-[50px]",
  shortDescription:
    "shortDescription font-bold text-[14px] leading-[30px] tracking-[0.53px] md:text-[21px] ",
}

export const FOOTER_PAGES = {
  richTextWrapper:
    "richTextWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-35 lg:px-15 mb-[50px]",
  title:
    "title badgeHeading font-MDLZBiteType text-black mb-[10px] text-[16px] text-center lg:text-left lg:text-[28px]",
  shortDescription:
    "shortDescription [&>p>a]:text-purple [&>p>a]:tracking-[2.2px] [&>p>a]:font-bold [&>p>a]:hover:text-orange [&>p>a]:hover:underline [&>p>em>a]:text-purple [&>p>em>a]:tracking-[2.2px] [&>p>em>a]:font-bold [&>p>em>a:hover]:text-orange [&>p>em>a:hover]:underline [&>ul>li>a]:text-purple [&>ul>li>a]:tracking-[2.2px] [&>ul>li>a]:font-bold [&>ul>li>a:hover]:text-orange [&>ul>li>a:hover]:underline [&>ul>li>li]:list-style-type-none",
}

export const H2_HEADING_GREEN_SMALL_DESC = {
  ...H2_HEADING_GREEN,
  richTextWrapper:
    "richTextWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-35 md:py-0 md:px-15",
  shortDescription:
    "shortDescription [&>p>a]:text-purple [&>p>a]:tracking-[2.2px] [&>p>a]:font-bold [&>p>a]:text-purple [&>p>a]:tracking-[2.2px] [&>p>a]:font-bold [&>p>a:hover]:text-orange [&>p>a:hover]:underline [&>p]:text-[14px] md:[&>p]:!text-[21px] [&>p]:md:leading-[31.5px] mb-[25px] md:mb-[25px] lg:mb-[35px]",
}

export const H2_HEADING_GREEN_AS_TITLE = {
  ...H2_HEADING_GREEN,
  richTextWrapper:
    "richTextWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto pb-35 px-35 md:py-0 md:px-15 lg:mb-50",
}

export const TEXT_WITH_BLUE_BG = {
  ...defaultStyle,
  richTextWrapperForBg: "md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto",
  richTextWrapper: "blueBg bg-blue500 m-20 p-40 text-white",
  title: "title text-[2.875rem] leading-[1em] font-MDLZBiteType mb-10",
  shortDescription: "",
}

export const HEADING_PARA = {
  ...defaultStyle,
  richTextWrapper:
    "richTextWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[15px] mb-[50px]",
  title:
    "title badgeHeading capitalize text-left font-Light text-[24px] lg:text-[48px] text-green mb-[35px] tracking-[1.2px] leading-[50px]",
  shortDescription:
    "shortDescription [&>p>a]:text-purple [&>p>a]:tracking-[2.2px] [&>p>a]:font-bold px-[20px] md:px-[20px] lg:px-[0px]",
}

export const TWO_COL_6_WIDTH = {
  ...defaultStyle,
  richTextWrapper:
    "richTextWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[15px]  flex items-center",
  shortDescription:
    "leftConetnt w-full md:w-1/2 shortDescription [&>p]:mb-20 [&>p>a]:text-purple [&>p>a]:tracking-[2.2px] [&>p>a]:font-bold px-[15px] [&>div>a>img]:w-full ",
  contentDescription: "contentDescription w-full md:w-1/2 px-[15px]",
}

export const SMALL_FONT_TEXT = {
  ...defaultStyle,
  richTextWrapper:
    "richTextWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[30px] md:px-[45px] lg:px-[30px] mb-[100px]",
  shortDescription: "text-[13px]",
}

export const LARGE_FONT_TEXT = {
  ...SMALL_FONT_TEXT,
  shortDescription:
    "text-[18px] font-['Times_New_Roman'] [&>p]:leading-[27px] [&>p>a]:font-bold hover:[&>p>a]:text-orange hover:[&>p>a]:text-orange hover:[&>p>a]:no-underline hover:[&>p>a]:border-b-2 hover:[&>p>a]:border-solid [&>p>a]:tracking-[0.53px] md:[&>p>a]:tracking-[2.2px] [&>p>a]:text-[14px] md:[&>p>a]:text-[21px] md:[&>p>a]:leading-[31.5px] [&>p>a]:leading-[21px] first:[&>p]:pt-[25px]",
}

export const H1_HEADING_PURPLE_WITH_BG = {
  ...H1_HEADING_PURPLE,
  richTextWrapper:
    "richTextWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-35 md:py-0 md:px-15",
  title:
    "title uppercase text-center md:text-left font-MDLZBiteType text-purple text-[36px] md:text-[60px] md:tracking-[1.2px] leading-[1.2] md:leading-[72px] max-w-[200px] md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto",
  richTextWrapperForBg:
    "richTextWrapperForBg bg-grayWhite py-[30px] md:py-[40px]",
}

export const OUR_BRANDS_PARA = {
  ...defaultStyle,
  richTextWrapper:
    "richTextWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[35px] md:px-[15px]",
  shortDescription:
    "shortDescription text-[14px] md:text-[30px] tracking-[0.35px] md:tracking-[0.75px] leading-[20px] md:leading-[40px]",
}

export const WITH_IMAGE = {
  ...defaultStyle,
  shortDescription:
    "shortDescription [&>p]:mb-20 [&>p>a]:text-purple [&>p>a]:tracking-[2.2px] [&>p>a]:font-bold [&>.contactPara]:mb-[60px] [&>.contactPara>p]:mb-0 [&>p>img]:float-left [&>p>img]:mr-10",
}
export const H2_HEADING_BLUE_AS_TITLE = {
  ...H2_HEADING_GREEN,
  title:
    "badgeHeading capitalize text-left font-[500] text-[24px] text-[#2d6eaa] lg:text-[28px] leading-[33px] mb-[8px] font-MDLZBiteType",
}

export const DOWNLOAD_LINK_TEXT = {
  title:
    "badgeHeading capitalize text-left font-[500] text-[24px] text-[#2d6eaa] lg:text-[28px] leading-[33px] mb-[8px] font-MDLZBiteType",
}

export const FOOTER_PAGES_WITH_BG = {
  ...FOOTER_PAGES,
  richTextWrapperForBg: "richTextWrapperForBg bg-[#f8f8f8] pb-[50px] mb-[50px]",
}
export const H3_BLACK_PURPLE_LINK = {
  ...defaultStyle,
  shortDescription:
    "shortDescription [&>p]:mb-20 [&>p>a]:text-purple [&>ul>li>a]:!text-[#4f2170] [&>ul>li>a:hover]:!text-orange [&>ul>li>a]:!leading-[31.5px] [&>ul>li>a]:font-bold [&>p>a]:tracking-[2.2px] [&>p>a]:font-bold [&>.contactPara]:mb-[60px] [&>.contactPara>p]:mb-0",
}

export const HEADING_CONTENT_YELLOW_BG = {
  richTextWrapper:
    "richTextWrapper bg-lightYellowBg border-black border-1 mx-16 md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[30px] md:px-[15px] lg:px-[15px] mb-[50px]",
  title:
    "title badgeHeading capitalize text-left  text-[15px] font-bold text-black pt-[5px] mb-[15px] tracking-[1.2px] leading-[22.5px]",
  shortDescription:
    "shortDescription [&>p]:mb-20 [&>p>a]:!text-purple [&>p>a:hover]:!text-orange [&>p>strong>a]:!text-[#4f2170] [&>p>strong>a:hover]:!text-orange [&>p>a]:tracking-[2.2px] [&>p>a]:font-bold [&>.contactPara]:mb-[60px] [&>.contactPara>p]:mb-0",
  selectWrapper: "selectWrapper mt-[30px] my-[50px]",
  selectDropdown: "selectDropdown",
}

export const BOLD_HEADING_LIST = {
  ...defaultStyle,
  richTextWrapper:
    "richTextWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[30px] md:px-[15px] lg:px-[15px] mb-[50px]",
  shortDescription:
    "shortDescription [&>p]:mb-20 [&>p>a]:!text-purple [&>div>p>ul>li>a]:font-bold [&>p>a:hover]:!text-orange [&>p>strong>a]:!text-[#4f2170] [&>p>strong>a:hover]:!text-orange [&>p>a]:tracking-[2.2px] [&>p>a]:font-bold [&>.contactPara]:mb-[60px] [&>.contactPara>p]:mb-0",
}

export const H2_HEADING_GREEN_WITH_SMALL_SIZE = {
  ...H2_HEADING_GREEN,
  richTextWrapper:
    "richTextWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[62px] md:px-[62px] mt-[20px] lg:px-[31px]",
  shortDescription:
    "font-['Times_New_Roman'] [&>section>p]:font-['Times_New_Roman'] [&>section>p]:leading-[27px] [&>section>p]:text-[18px] md:text-[18px] [&>section>p>a]:!text-purple [&>section>p>a]:!tracking-[2.2px] [&>section>p>a]:!font-bold [&>section>p>a]:font-Regular hover:[&>section>p>a]:!text-orange hover:[&>section>p>a]:!border-b-2 [&>section>p>a]:text-[14px] md:[&>section>p>a]:text-[21px] hover:[&>section>p>a]:no-underline [&>section>h2]:text-left [&>section>h2]:font-Light [&>section>h2]:text-[24px] lg:[&>section>h2]:text-[48px] [&>section>h2]:text-green [&>section>h2]:mb-[35px] [&>section>h2]:tracking-normal [&>section>h2]:leading-[28.8px] md:[&>section>h2]:leading-[57.6px]",
}

export const BLACK_TEXT_CONTENT = {
  richTextWrapper:
    "richTextWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[15px] md:px-[15px] lg:px-[15px] pb-[30px] lg:pb-[50px] py-35 md:py-[0px]",
  title:
    "title badgeHeading text-left font-Light text-[24px] lg:text-[48px] text-green mb-[35px] tracking-normal md:leading-[50px] test",
  shortDescription:
    "shortDescription [&>p]:mb-20 [&>p]:text-center md:[&>p]:text-left [&>p]:text-[16px] [&>p]:font-['Segoe_UI'] [&>p>a]:!text-purple [&>p>a:hover]:!text-orange [&>p>strong>a]:!text-[#4f2170] [&>p>strong>a:hover]:!text-orange [&>p>a]:tracking-[0.53px] md:[&>p>a]:!tracking-[2.2px] [&>p>a]:font-bold [&>.contactPara]:mb-[60px] [&>.contactPara>p]:mb-0 [&>ul>li>a]:font-bold [&>ul>li>a]:tracking-[2.2px] [&>ul]:mb-[35px] [&>ul>li>a]:!text-purple [&>ul>li>a:hover]:!text-orange [&>ul>li>a]:tracking-[2.2px] [&>ul>li>a]:font-bold [&>ul]:mb-16 break-words md:px-[20px] lg:px-[0px] [&>section>h2]:text-[#287819] [&>section>h2]:text-[48px] [&>section>h2]:font-[300] [&>section>h2]:mb-[35px] [&>section>h2]:font-Light [&>section>span]:text-16 [&>.careerPara]:text-center [&>.careerPara]:py-[30px] [&>.careerPara]:lg:py-[50px]",
  selectWrapper: "selectWrapper mt-[30px] my-[50px]",
  selectDropdown: "selectDropdown",
}

export const BRAND_AMBASEDER_SOCIAL = {
  richTextWrapper:
    "richTextWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[35px] md:px-[15px] lg:px-[15px] pb-[30px] lg:pb-[50px] py-35 md:pt-[0px] brand-ambaseder-social",
  title:
    "title badgeHeading text-left font-Light text-[24px] lg:text-[48px] text-green mb-[35px] tracking-normal md:leading-[50px] test",
}

export const TREND_RADAR_CHART_PAGE = {
  richTextWrapperForBg: "max-width-wrapper px-35 md:px-15 MDLZBiteType",
  title:
    "text-[48px] lg:text-64 leading-none lg:leading-[0.75] text-gray800 font-bold",
  shortDescription:
    "text-24 mt-12 lg:mt-6 leading-[1.333] text-black font-normal",
}

export const SNACKIG_RIGHT_CHART_TEXT = {
  richTextWrapper: "richTextWrapper xl:pl-[48px]",
  shortDescription:
    "description font-BwSurco [&>p:nth-child(even)]:mb-[48px] [&>p:nth-child(odd)]:mb-[8px] [&>p>strong]:text-[26px] [&>p>strong]:leading-[31.2px] text-[18px] leading-[21.6px]",
  contentDescription:
    "absolute bottom-[-85px] xl:bottom-[-25px] left-0 right-0 text-center text-[26px] leading-[31.2px] font-BwSurco font-bold px-20 xl:px-0",
}

export const MAKING_COCOA_TITLE = {
  richTextWrapperForBg: "section-cocoa-right pt-40 pb-40 mt-[-2px] relative",
  richTextWrapper: "lg:max-w-lg xl:max-w-[1196px] mx-auto px-0",
  title:
    "font-MDLZBiteType text-[60px] leading-[72px] lg:text-[72px] lg:leading-[86.4px] text-purple text-center mb-32 lg:mb-40 tracking-normal",
  shortDescription:
    "font-BwSurco text-[20px] leading-[24px] text-black text-left tracking-normal [&>p>strong]:block [&>p>strong]:text-[26px] [&>p>strong]:leading-[31.2px] [&>p>strong]:text-center",
  imageWrapperMedium:
    "makingcocoatitle imageWrapperMedium absolute left-0 lg:left-30 lg:top-[-10px] top-[-70px] hidden lg:block",
  imageWrapperLarge:
    "makingcocoatitle imageWrapperLarge absolute right-auto left-0 lg:left-auto lg:right-0 top-[-60px] lg:top-[-100px] hidden lg:block w-[21%] xl:w-auto",
}

export const MAKING_COCOA_TITLE_GRAYBG = {
 ...MAKING_COCOA_TITLE,
 richTextWrapperForBg: "section-cocoa-right bg-grayWhite py-[20px] lg:pt-40 lg:pb-40 mt-[-2px] relative",
 title: "font-MDLZBiteType text-[60px] leading-[72px] lg:text-[72px] lg:leading-[86.4px] text-purple text-center mb-0 lg:mb-40 tracking-normal",
}

export const COCOA_LIFE_PILLER_TITLE = {
  richTextWrapperForBg: "bg-[#faf3e7] pt-100 pb-80 vector-1 relative",
  richTextWrapper: "lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 xl:px-0",
  title:
    "font-MDLZBiteType text-[60px] leading-[72px] text-DarkPurple text-center mb-32",
  shortDescription:
    "font-BwSurco text-[20px] leading-[24px] text-black text-left tracking-normal",
}

export const TOP_MAIN_TITLE_PURPLE = {
  richTextWrapperForBg:
    "section-sustainable pt-[100px] lg:pt-60 pb-20 mt-[-2px]",
  richTextWrapper: "lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 xl:px-0",
  title: "font-MDLZBiteType text-[60px] leading-[72px] text-purple text-center",
  shortDescription:
    "font-BwSurco text-[20px] leading-[24px] text-black text-left [&>p>strong]:block [&>p>strong]text-[26px] [&>p>strong]:leading-[31.2px] [&>p>strong]:mb-80 [&>p>strong]:text-center",
  imageWrapperMedium:
    "top-main imageWrapperMedium absolute left-0 lg:bottom-auto lg:top-[-65px] top-[-60px] w-[30%] xl:w-auto z-20",
  imageWrapperLarge:
    "top-main imageWrapperMedium absolute lg:left-30 left-0 lg:bottom-auto lg:top-[-65px] top-[-120px] z-20",
}

export const EMPOWERING_COCOA_TITLE = {
  richTextWrapperForBg: "empowering-cocoa pt-60 pb-0 mt-[-2px]",
  richTextWrapper: "lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 xl:px-0",
  title:
    "font-MDLZBiteType text-[60px] leading-[72px] text-purple text-center mb-32",
  shortDescription:
    "font-BwSurco text-[20px] leading-[24px] text-black text-left [&>p>strong]:block [&>p>strong]:text-[26px] [&>p>strong]:leading-[31.2px] [&>p>strong]:mb-40 [&>p>strong]:text-center tracking-normal",
  imageWrapperMedium:
    "absolute right-0 lg:bottom-auto lg:top-[-120px] top-[-280px] z-10 [&>img]:w-full",
  imageWrapperLarge:
    "absolute right-0 lg:bottom-auto lg:top-[-110px] top-[-165px] z-10 w-[45%] md:w-[32%] lg:w-[20%] [&>img]:w-full",
}

export const SECTION_DELICIOUSLY = {
  richTextWrapperForBg: "sectiom-deliciously pt-60 pb-0 mt-[-2px]",
  richTextWrapper: "lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 lg:px-0",
  title:
    "font-MDLZBiteType text-[60px] leading:[72px] lg:text-[72px] lg:leading:[86.4px] text-purple text-center mb-32",
  shortDescription:
    "font-BwSurco text-[20px] leading-[24px] text-black text-left [&>p>strong]:block [&>p>strong]:text-[26px] [&>p>strong]:leading-[31.2px] [&>p>strong]:mb-40 [&>p>strong]:text-center [&>p]:tracking-normal text-center",
  imageWrapperMedium:
    "sectiondelici imageWrapperMedium absolute inline-flex justify-end top-[-80px] left-auto right-0 lg:top-[-180px] hidden lg:block w-[24%] xl:w-auto",
  imageWrapperLarge:
    "sectiondelici imageWrapperLarge absolute left-0 top-[-180px] xl:top-[-240px] z-10",
}

export const TITLE_PROTECTING = {
  richTextWrapperForBg: "section-protecting pt-60 mt-[-2px]",
  richTextWrapper: "lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 xl:px-0",
  title:
    "font-MDLZBiteType text-[60px] leading:[72px] lg:text-[72px] lg:leading:[86.4px] text-purple text-center mb-32",
  shortDescription:
    "font-BwSurco text-[20px] leading-[24px] text-black text-left [&>p>strong]:block [&>p>strong]:text-[26px] [&>p>strong]:leading-[31.2px] [&>p>strong]:mb-40 [&>p>strong]:text-center tracking-normal [&>h3]:text-[26px] [&>h3]:leading-[31.2px] [&>h3]:pt-[48px] [&>h3]:text-center [&>h3]:font-normal",
  imageWrapperMedium:
    "title-protecting imageWrapperMedium absolute left-0 lg:left-60 lg:bottom-auto top-[-140px] lg:top-[-120px] z-10 w-[35%] md:w-[25%] lg:w-[17%] xl:w-auto",
  imageWrapperLarge:
    "title-protecting imageWrapperLarge absolute left-0 lg:left-60 lg:bottom-auto top-[-140px] lg:top-[-120px] z-10",
}

export const TITLE_PLASTICS = {
  richTextWrapperForBg: "section-plastics pt-40 pb-0",
  richTextWrapper:
    "xl:max-w-[1196px] mx-auto px-20 xl:px-0 text-DarkPurple text-20 leading-24 font-BwSurco",
  title:
    "font-MDLZBiteType text-[60px] leading-[72px] xl:text[72px] xl:leading-[86.4px] text-center mb-24 xl:mb-32",
  shortDescription:
    "font-BwSurco text-[20px] leading-[24px] text-left [&>p>strong]:block [&>p>strong]:text-[26px] [&>p>strong]:leading-[31.2px] [&>p>strong]:mb-40 [&>p>strong]:text-center [&>h3]:text-[26px] [&>h3]:leading-[31.2px] [&>h3]:pt-[48px] [&>h3]:text-center [&>h3]:font-bold",
  contentDescription: "font-BwSurco text-[20px] leading-[24px] text-DarkPurple",
  imageWrapperMedium:
    "title-plastic imageWrapperMedium absolute inline-flex justify-center lg:justify-end right-0 lg:right-30 lg:bottom-auto lg:top-[-100px] top-[-80px] z-20 w-auto md:w-[28%] xl:w-auto",
  imageWrapperLarge:
    "title-plastic imageWrapperLarge absolute inline-flex justify-center lg:justify-end right-0 lg:right-30 lg:bottom-auto lg:top-[-100px] top-[-80px]",
}

export const COCOA_PROGRAM_TITLE = {
  richTextWrapperForBg: "section-cocoa-program py-60 mt-[-2px]",
  richTextWrapper: "lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 xl:px-0",
  title:
    "font-MDLZBiteType text-[60px] leading-[72px] lg:text-[72px] lg:leading-[86.4px] text-white text-center mb-32",
  shortDescription:
    "font-BwSurco text-[20px] leading-[24px] text-white text-left [&>p>strong]:block [&>p>strong]:text-[26px] [&>p>strong]:leading-[31.2px] [&>p>strong]:mb-32 lg:[&>p>strong]:mb-40 [&>p>strong]:text-center",
}

export const CIRCULAR_FUTURE_BOTTM_TEXT = {
  richTextWrapperForBg:
    "section-circular pt-80 lg:pb-60  bg-[#B5BF5E] relative z-10 pb-100 lg:pb-80",
  richTextWrapper: "lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 xl:px-0",
  title: "",
  shortDescription:
    "font-BwSurco text-[20px] leading-[24px] text-black text-left [&>p>strong]:block [&>p>strong]:text-[26px] [&>p>strong]:leading-[31.2px] [&>p>strong]:mb-40 [&>p>strong]:text-center [&>h3]text-[26px] [&>h3]:leading-[31.2px] [&>h3]:pt-[48px] [&>h3]:text-center [&>h3]:font-bold",
}

export const TITLE_AWARDS = {
  richTextWrapperForBg: "section-awards pt-100 pb-[80px] mt-[-2px]",
  richTextWrapper: "lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 xl:px-0",
  title:
    "font-MDLZBiteType text-[60px] leading-[72px] text-[#FDC583] text-center mb-32",
  shortDescription: "",
}

export const TITLE_LEGACY_SHARED = {
  richTextWrapperForBg: "pt-100 pb-[48px] legacy-shared relative",
  richTextWrapper: "lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 xl:px-0",
  title:
    "font-MDLZBiteType text-[60px] leading-[72px] text-purple text-center mb-[32px]",
  shortDescription:
    "font-BwSurco text-[20px] leading-[24px] text-black text-left tracking-normal [&>p>strong]:block [&>p>strong]:mb-80 [&>p>strong]:text-center [&>p>strong]:text-[26px] [&>p>strong]:leading-[31.2px]",
}

export const BRANDS_THAT_SPEAK_HEADING = {
  richTextWrapperForBg: "bg-[#D4B7EC] pt-60 pb-[40px] vector-1 relative",
  richTextWrapper: "md:max-w-md lg:max-w-lg xl:max-w-[1196px] mx-auto px-0",
  title:
    "font-MDLZBiteType text-[60px] leading-[72px] lg:text-[72px] lg:leading:[86.4px] text-purple text-center",
  shortDescription: "",
  imageWrapperMedium:
    "brandspeak imageWrapperMedium absolute right-0 top-[59%] lg:top-[-100px] lg:bottom-auto z-10 lg:w-[16%] xl:w-auto",
  imageWrapperLarge:
    "brandspeak imageWrapperLarge absolute right-0 top-[59%] lg:top-15 lg:bottom-auto z-10",
}

export const BRANDS_THAT_SPEAK_DESCRIPTION = {
  richTextWrapperForBg: "bg-[#D4B7EC] pb-[40px] relative",
  richTextWrapper: "lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 xl:px-0",
  title: "",
  shortDescription:
    "font-BwSurco text-[20px] leading-[24px] text-black text-left tracking-normal",
}

export const EMPOWERING_PEOPLE_TITLE = {
  richTextWrapperForBg:
    "empowering-people bg-[#4F2170] pt-80 lg:pt-40 pb-[40px] relative",
  richTextWrapper: "lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 xl:px-0",
  title:
    "font-MDLZBiteType text-[60px] leading-[72px] lg:text-[72px] lg:leading-[86.4px] text-[#FDC583] text-center mb-32",
  shortDescription:
    "font-BwSurco text-[26px] leading-[32px] text-white text-center",
  imageWrapperMedium:
    "empoweringpeople imageWrapperMedium absolute inline-flex justify-center lg:justify-start right-0 lg:bottom-auto lg:top-15 top-[-80px] w-full lg:w-[18%]",
  imageWrapperLarge:
    "empoweringpeople imageWrapperLarge absolute inline-flex justify-center lg:justify-start left-0 lg:bottom-auto lg:top-15 top-[-80px] w-full lg:w-[18%]",
}
export const OUR_PROMISE_KIDS = {
  richTextWrapperForBg: "bg-[#faf3e7] pt-40 pb-60 text-center relative z-10",
  richTextWrapper: "lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 xl:px-0",
  title:
    "text-[26px] leading-[31.2px] lg:text-[32px] lg:leading-[38.4px] font-BwSurcoBold mb-10 text-DarkPurple",
  shortDescription: "font-BwSurco text-[20px] leading-[24px] text-black",
}

export const COMMUNITY_TXT_CONTENT = {
  richTextWrapperForBg:
    "community-initative mt-[-2px] w-full relative mx-auto bg-[#4F2170] px-20 lg:px-0",
  richTextWrapper:
    "lg:max-w-lg xl:max-w-[1196px] mx-auto text-white pt-[100px] lg:pt-[60px] pb-[40px]",
  title:
    "text-center font-MDLZBiteType text-60 leading-[72px] xl:text-[72px] xl:leading-[86.4px] pb-[32px]",
  shortDescription:
    "text-center text-[26px] leading-[31.2px] font-BwSurco font-[500]",
  contentDescription:
    "mt-[40px] text-[20px] leading-[24px] font-[400] font-BwSurco first:[&>p]:mb-[16px]",
  imageWrapperMedium:
    "communitycontent imageWrapperMedium absolute right-0 lg:bottom-auto lg:top-15 top-[-100px]",
  imageWrapperLarge:
    "communitycontent imageWrapperLarge absolute right-0 lg:bottom-auto lg:top-15 top-[-100px]",
}

export const COMMUNITY_PLAIN_TXT_CONTENT = {
  richTextWrapperForBg: "mx-auto bg-[#4F2170] px-20 lg:px-0",
  richTextWrapper: "lg:max-w-lg xl:max-w-[1196px] mx-auto text-white pb-[40px]",
  title:
    "text-center font-MDLZBiteType text-48 leading-[57.6px]  xl:text-[48px] xl:leading-[57.6px] mb-[32px]",
  contentDescription: "text-[20px] leading-[24px] font-[400] font-BwSurco",
}

export const COMMUNITY_NUTRITION_ONLY_TITLE = {
  richTextWrapperForBg: "richTextWrapperForBg",
  richTextWrapper: "richTextWrapper px-20 lg:px-0",
  title:
    "title text-60 leading-[72px] xl:text-[72px] xl:leading-[86.4px] font-[400] font-MDLZBiteType text-[#4F2170] text-center",
  shortDescription:
    "text-[#4F2170] text-[26px] leading-[31.2px] font-[500] font-BwSurco text-center mt-[24px]",
  contentDescription:
    "text-black lg:max-w-lg xl:max-w-[1196px] mx-auto text-[20px] leading-[24px] tracking-normal font-[400] font-BwSurco mt-[40px] mb-[60px]",
}

export const DIVIDER = {
  richTextWrapper: "richTextWrapper lg:max-w-lg xl:max-w-[1196px] mx-auto",
}

export const SNACKING_OUR_MISSION = {
  richTextWrapperForBg: "pt-100 lg:pt-60 pb-40 bg-[#562F23] relative z-10",
  richTextWrapper: "lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 xl:px-0",
  title:
    "font-MDLZBiteType text-[60px] leading-[72px] lg:text-[72px] lg:leading-[86.4px] text-white text-center mb-32",
  shortDescription:
    "font-BwSurco text-[20px] leading-[24px] text-white text-left [&>p>strong]:block [&>p>strong]:text-[26px] [&>p>strong]:leading-[31.2px] [&>p>strong]:mb-40 [&>p>strong]:text-center mb-[48px]",
  contentDescription:
    "font-BwSurco text-[26px] leading-[31.2px] text-white text-center",
  imageWrapperMedium:
    "snackingmission imageWrapperMedium absolute inline-flex justify-end left-0 lg:bottom-auto lg:top-15 top-[-120px] lg:top-[-100px] w-full",
  imageWrapperLarge:
    "snackingmission imageWrapperLarge absolute inline-flex justify-end left-0 lg:bottom-auto lg:top-15 top-[-100px] w-full",
}
export const SNACKING_MADE_RIGHT_LAST = {
  richTextWrapperForBg: "bg-[#FFD8AA] pt-80 pb-80 snacking-last relative",
  richTextWrapper: "lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 xl:px-0",
  title:
    "font-MDLZBiteType text-[60px] leading-[72px] lg:text-[72px] lg:leading-[86.4px] text-purple text-center mb-[24px]",
  shortDescription:
    "font-BwSurco text-[26px] leading-[31.2px] text-purple tracking-normal text-center",
}
export const ROADMAP_COMING_YEAR_TITLE = {
  richTextWrapperForBg: "roadComingYearBg pt-[60px] pb-[30px] px-20 xl:px-0",
  richTextWrapper: "container mx-auto",
  title:
    "title text-[60px] leading-[72px] xl:text-[72px] xl:leading-[86.4px] font-[400] font-MDLZBiteType text-[#4F2170] text-center",
  shortDescription:
    "text-[#4F2170] text-[26px] leading-[31.2px] font-[500] font-BwSurco text-center mt-[24px]",
  contentDescription:
    "text-[14px] leading-[16.8px] font-[500] font-BwSurco text-black text-center mt-[80px] lg:hidden relative",
  imageWrapperMedium:
    "roadmap imageWrapperMedium absolute right-0 lg:bottom-auto lg:top-[-100px] top-[-80px] hidden lg:block",
  imageWrapperLarge:
    "roadmap imageWrapperLarge absolute right-0 lg:bottom-auto lg:top-[-100px] top-[-80px]",
}

export const TITLE_SUSTAINABLE = {
  richTextWrapperForBg:
    "section-sustainableagri pt-100 lg:pt-60 pb-0 mt-[-2px]",
  richTextWrapper: "xl:max-w-[1196px] mx-auto px-20 xl:px-0 text-white",
  title:
    "font-MDLZBiteType text-[60px] leading-[72px] xl:text-[72px] xl:leading-[86.4px] text-center",
  imageWrapperMedium:
    "titlesus imageWrapperMedium absolute left-0 top-[-90px] lg:top-[-70px] lg:bottom-auto z-10 w-[29%] lg:w-[22%]",
  imageWrapperLarge:
    "titlesus imageWrapperMedium absolute left-0 top-[-90px] lg:top-[-70px] lg:bottom-auto z-10 w-[22%]",
}

export const ROADMAP_LINK = {
  richTextWrapperForBg: "richTextWrapperForBg sticky top-0 bg-[#faf3e7] z-50",
  richTextWrapper: "roadmap-links containerWrapper container mx-auto",
  shortDescription:
    "shortDescription [&>div]:flex [&>div]:flex-col [&>div]:lg:flex-row [&>div]:justify-around pt-[50px] [&>div>ul]:pl-[35px] [&>div>ul]:pr-[30px] [&>div>ul]:mb-[30px] text-[14px] md:text-[21px] text-[#4f2170] font-normal [&>div>ul>li>a]:font-bold md:font-Regular tracking-[0.53px] md:tracking-[2.2px]",
}

export const OVERALL_IMPACT = {
  richTextWrapperForBg:
    "overall-impact containerWrapper lg:max-w-lg xl:max-w-[1196px] mx-auto rounded-b-[20px] relative px-20 lg:px-0",
  richTextWrapper: "lg:p-[40px] mb-[80px] bg-[#FAF3E7]",
  shortDescription:"bg-[#FDC583] rounded-[20px] [&>p]:p-[30px] [&>p]:flex [&>p]:flex-wrap lg:[&>p]:flex-nowrap [&>p]:items-center [&>p>strong]:uppercase [&>p]:font-MDLZBiteType [&>p]:text-[20px] [&>p]:leading-[24px] [&>p]:text-[#651935] [&>p]:uppercase",
}

export const TWO_COL_TEAMS = {
  ...defaultStyle,
  shortDescription:"text-21 mt-12 lg:mt-6 leading-[1.333] flex flex-wrap lg:flex-nowrap gap-[30px] max-w-[850px] justify-between font-normal" 
}
